import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRef, useEffect, useReducer } from 'react';

var useLatestRef = function useLatestRef(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref;
}; // eslint-disable-next-line object-property-newline


var merge = function merge(state, newState) {
  return _objectSpread(_objectSpread({}, state), newState);
};

var runRef = function runRef(ref) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return ref.current && ref.current.apply(ref, _toConsumableArray(args));
};

export var useScript = function useScript(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onLoad = _ref.onLoad,
      onError = _ref.onError,
      onComplete = _ref.onComplete;

  var _useReducer = useReducer(merge, {
    loaded: false,
    error: null
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      loaded = _useReducer2$.loaded,
      error = _useReducer2$.error,
      setState = _useReducer2[1];

  var savedLoad = useLatestRef(onLoad);
  var savedError = useLatestRef(onError);
  var savedComplete = useLatestRef(onComplete);
  useEffect(function () {
    var script = document.createElement('script');
    script.src = url;
    script.async = 1;

    var loadedFine = function loadedFine() {
      setState({
        loaded: true
      });
      runRef(savedLoad);
      runRef(savedComplete);
    };

    var loadedWithError = function loadedWithError(error) {
      setState({
        error: error
      });
      runRef(savedError, [error]);
      runRef(savedComplete);
    };

    script.addEventListener('load', loadedFine);
    script.addEventListener('error', loadedWithError);
    document.body.appendChild(script);
    return function () {
      script.removeEventListener('load', loadedFine);
      script.removeEventListener('error', loadedWithError);
      script.parentNode.removeChild(script);
    };
  }, [savedComplete, savedError, savedLoad, url]);
  return [loaded, error];
};